import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center px-6 text-center">
      <div data-testid="payment-cancel-page" className="max-w-md">
        <XCircle size={56} className="text-[#A1A1AA] mx-auto mb-4" />
        <h1 className="font-heading text-4xl text-white tracking-tight mb-2">Checkout Cancelled</h1>
        <p className="text-[#A1A1AA] mb-8">No charge was made. You can pick a package whenever you're ready.</p>
        <Link to="/#services" data-testid="payment-cancel-home-link" className="inline-block bg-[#D4AF37] text-black rounded-full px-8 py-3 font-semibold tracking-wide hover:bg-[#c29f2f] transition-colors">
          View Packages
        </Link>
      </div>
    </div>
  );
}
